import { uniqueOrArrayToArray } from '../../generic/array';
import { UseCase } from './UseCase';
export class EraseUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return Promise.all(uniqueOrArrayToArray(event.entityIdToErase).map(entityId => this.applicationServices.interface.removeEntityInterfaceState(entityId)))
            .then(results => Promise.resolve())
            .catch(error => Promise.reject(error));
    }
}
